module.exports = __webpack_public_path__ + "static/media/aboutUs3.21ca5642.jpg";